<template>
  <v-card :loading="showDialogProgress" :disabled="showDialogProgress">
    <div class="ExtraWorkManagement">
      <request-management-search-panel :accessTo="accessTo" @search="setSearchParams" />

      <box class="mt-2" :title="$t('extraWorkList')">
        <div class="extraWorkList">
          <div v-if="list.length > 0">
            <v-alert class="ma-2" dense border="left" colored-border color="green" elevation="2"
              icon="mdi-alert-circle-outline">
              <div class="text-small">
                توجه : سطر های سبز رنگ برگه های اضافه کار گروهی هستند و ممکن است
                در شرایط تمام درخواست ها مشاهده نشوند.
              </div>
            </v-alert>
            <extra-work-management-list-web :pagination="true" :list="list" class="hidden-sm-and-down"
              @onClick="onClickExtraWork" />
            <extra-work-management-list-mob @onClick="onClickExtraWork" :list="list" class="hidden-md-and-up" />
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="d-flex px-4 py-2">
                <v-btn outlined color="primary" small :disabled="disabledBtn" @click="approveSelected">{{
                  $t("approveSelected")
                }}</v-btn>
                <v-btn outlined color="primary" class="mx-2" small @click="rejectSelected">{{ $t("rejectSelected")
                  }}</v-btn>
              </div>
            </v-card-actions>
          </div>
          <div v-else>
            <EmptyList />
          </div>
        </div>
      </box>
      <extra-work-management-details class="mt-2" ref="ExtraWorkManagementDetails" @refresh="search"
        @operationOnRequest="operationOnRequestDetails" />
    </div>
  </v-card>
</template>

<script>
import RequestManagementSearchPanel from "../../components/requestManagement/RequestManagementSearchPanel.vue";
import RequestState from "@/model/RequestState";
import ResultType from "../../model/ResultType";
import AccessToType from "../../model/AccessToType";
import ExtraWorkManagementListWeb from "../../components/requestManagement/extrawork/ExtraWorkManagementListWeb.vue";
import ExtraWorkManagementListMob from "../../components/requestManagement/extrawork/ExtraWorkManagementListMob.vue";
import ExtraWorkManagementDetails from "../../components/requestManagement/extrawork/ExtraWorkManagementDetails.vue";
import TextUtils from "../../utils/TextUtils";
import EosToastType from "../../model/EosToastType";
import EosUtils from "../../utils/EosUtils";
import PushNotificationHelper from '../../notification/PushNotificationHelper';

export default {
  components: {
    RequestManagementSearchPanel,
    ExtraWorkManagementListWeb,
    ExtraWorkManagementListMob,
    ExtraWorkManagementDetails,
  },
  data() {
    return {
      accessTo: -1,
      list: [],
      searchParams: {},
      showDialogProgress: false,
      disabledBtn: false,
    };
  },
  created() {
    this.accessTo = AccessToType.ExtraWork;
    //console.log(this.accessTo);
  },
  methods: {
    setSearchParams(params) {
      this.searchParams = params;
      //debugger
      this.search();
    },
    search() {
      //debugger
      ////console.log(params);
      ////debugger;
      var params = this.searchParams;
      this.list = [];
      this.$store
        .dispatch("GetExtraWorkListForAdmin", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            ////debugger;
            this.list = result.data;
          }
        });
    },
    onClickExtraWork(item) {
      this.hideDetails();
      //console.log(item);
      this.$refs.ExtraWorkManagementDetails.show(item, item);
      /*const params = new URLSearchParams();
      params.append("pageNo", TextUtils.convertToEnglishDigits(item.Pageno));
      params.append("dbkind", item.DBKind);
      params.append("year", item.Year);

      this.$store
        .dispatch("GetVacationDetailForPerson", { params })
        .then((result) => {
          if (result.type == "success") {
            if (result.data.length > 0) {
              let details = result.data[0];
              this.$refs.VacationArchiveDetails.show(item, details);
            }
          }
        });*/
    },
    hideDetails() {
      this.$refs.ExtraWorkManagementDetails.hide();
    },
    approveSelected() {
      this.disabledBtn = true; // Disable the button
      this.showDialogProgress = true; // Show progress dialog
      const selectedList = this.list.filter((item) => item.select === true);
      const requestState = RequestState.RequestState.Approve;
      this.OprationOnRequest(requestState, selectedList);

    },
    rejectSelected() {
      var selectedList = this.list.filter((item) => item.select === true);
      var requestState = RequestState.RequestState.Reject;
      this.OprationOnRequest(requestState, selectedList);
    },
    operationOnRequestDetails(requestState, selectedList) {
      this.OprationOnRequest(requestState, selectedList);
    },
    OprationOnRequest(requestState, selectedList) {
      //console.log(selectedList);
      var params = [];
      var adminPerno = this.$store.state.auth.auth.username;


      if (EosUtils.isWebKartAdmin()) {
        //
        selectedList.forEach((item) => {
          var param = {
            PageNo: TextUtils.convertToEnglishDigits(
              item.PAGENO.toString().trim()
            ),
            Year: item.Year,
            adminPerno: adminPerno,
            perno: TextUtils.convertToEnglishDigits(
              item.perno.toString().trim()
            ),
            RequestState: requestState,
            ReasonOfAdmin: "",
            Status: 10,
            IsSpecificEw: false,
          };
          params.push(param);
        });
        this.OprationOnExtraWorkRequest(params);
      } else {
        //
        let callback = function (resList) {
          //console.log(resList);
          resList.forEach((res, index) => {
            if (res.type === ResultType.success) {
              var s = res.data;
              //console.log(s, index);
              var item = selectedList[index];
              var param = {
                PageNo: TextUtils.convertToEnglishDigits(
                  item.PAGENO.toString().trim()
                ),
                Year: item.Year,
                adminPerno: adminPerno,
                perno: TextUtils.convertToEnglishDigits(
                  item.perno.toString().trim()
                ),
                RequestState: requestState,
                ReasonOfAdmin: "",
                Status: s,
                IsSpecificEw: false,
              };
              params.push(param);
            }
          });
        };
        if (selectedList.length > 0) {
          this.GetApproveDegree(selectedList, callback).then(() => {
            this.OprationOnExtraWorkRequest(params);
          });
        }
      }


    },
    async GetApproveDegree(list, callback) {
      let promises = [];
      list.forEach((item) => {
        //console.log(item);
        var approveParams = {
          perno: TextUtils.convertToEnglishDigits(item.perno.toString().trim()),
          section: TextUtils.convertToEnglishDigits(
            item.section.toString().trim()
          ),
          status: TextUtils.convertToEnglishDigits(
            item.status.toString().trim()
          ),
          isSpecificEw: false,
        };

        promises.push(
          this.$store.dispatch("GetExtraWorkApproveDegree", { approveParams })
        );
      });

      await Promise.all(promises)
        .then(callback)
        .catch((err) => {
          console.log(err);
        });
    },
    OprationOnExtraWorkRequest(params) {
      //console.log(params);
      this.disabledBtn = true; // Disable the button
      this.showDialogProgress = true; // Show progress dialog

      this.$store
        .dispatch("OprationOnExtraWorkRequest", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.search();
            if (result.data && result.data.length > 0) {
              var description = result.data[0].Description;
              this.$EosToast.show({
                type: EosToastType.success,
                msg: description,
              });
              this.disabledBtn = false;
              this.showDialogProgress = false;
              //this.$refs.snackbar.show("success", description);
              params.forEach((param) => {
                PushNotificationHelper.sendNotification(
                  param.adminPerno,
                  param.perno,
                  param.RequestState,
                  param.RequestState
                );
              });
            }
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error,
            });
            this.disabledBtn = false;
            this.showDialogProgress = false;
            //this.$refs.snackbar.show("error", result.error);
          }
        });
    },
  },
};
</script>

<style></style>
